// extracted by mini-css-extract-plugin
module.exports = {"link":"Item_link__2N8hY","icon":"Item_icon__3ign5","infoIcon":"Item_infoIcon__3Anf9","cell":"Item_cell__33bMR"};